import React, { useState, useEffect } from "react";
import { Link as ScrollLegacyLink } from "react-scroll";
import logo from "./../../images/logo-big-shop.png";
import { NavLink as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";

// import {Link} from 'react-scroll'

function Navbar2({ forceSmallHeader = false }) {
  const [navToggle, setnavToggle] = useState(true);
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 768px)").matches
  );
  const [showServicesList, setShowServicesList] = useState(false);
  const [showEventsList, setShowEventsList] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const apply = () => {
      setIsMobile(mq.matches);
      if (!mq.matches) {
        setShowServicesList(false);
        setShowEventsList(false);
      }
    };
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else mq.addListener(apply);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", apply);
      else mq.removeListener(apply);
    };
  }, []);

  useEffect(() => {
    if (forceSmallHeader) return;
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [forceSmallHeader]);

  const small = forceSmallHeader || isScrolled;
  // Desktop: the open side navigation uses icons only; fixed/compact bars show labels.
  const iconsOnly = !isMobile && !small;
  const showRotatedLabels = !isMobile && !small;

  // On mobile, Mission opens its submenu as an accordion; Events navigates
  // directly to the Events page.
  const isMobileNow = () =>
    typeof window !== "undefined" &&
    (window.matchMedia("(max-width: 768px)").matches || isMobile);

  const onMissionClick = (e) => {
    if (isMobileNow()) {
      e.preventDefault();
      e.stopPropagation();
      setShowServicesList((v) => !v);
      setShowEventsList(false);
    }
  };

  const onEventsClick = (e) => {
    if (isMobileNow()) {
      closeMobileMenu();
    }
  };

  // Collapse the whole mobile menu after tapping any real navigation link
  // (i.e. anything that isn't one of the submenu toggles above).
  const closeMobileMenu = () => {
    setnavToggle(true);
    setShowServicesList(false);
    setShowEventsList(false);
  };

  const onPanelClick = (e) => {
    if (!isMobile) return;
    const link = e.target.closest("a");
    if (!link) return;
    if (link.classList.contains("services-link")) return; // submenu toggles
    closeMobileMenu();
  };

  return (
    <>
      {/* Layout2-only submenu rules */}
      {forceSmallHeader && (
        <style>{`
          /* prevent clipping in fixed header */
          .header-top-fixed.force-small-header .header-body,
          .header-top-fixed.force-small-header .header-body-fixed { overflow: visible !important; }

          .navbar.is-layout2 { position: relative; z-index: 9999; }
          .navbar.is-layout2 .service { position: relative; z-index: 1; }

          /* ===== LEFT-ALIGNED solid submenu panel ===== */
          .navbar.is-layout2 .service > .sub-menu-container{
  position:absolute;
  top:calc(100% + 6px);
  left:0;
  right:auto;
  transform:none;
  display:none;

  padding:8px;              /* reduced inner spacing */
  min-width:240px;          /* smaller width */
  max-width:380px;          /* reduce hover panel length */
  max-height:calc(100vh - 120px);
  overflow-x:hidden;
  overflow-y:auto;
  overscroll-behavior:contain;
  scrollbar-gutter:stable;

  border-radius:12px;
  border:1px solid rgba(255,255,255,.16);
  box-shadow:0 12px 30px rgba(0,0,0,.28);

  background:rgba(0,0,0,.72) !important;
  z-index:100000;
  isolation:isolate;
}

          /* Kept only as a backing layer; the scrollable panel itself owns the background. */
          .navbar.is-layout2 .service > .sub-menu-container::after{
            content:"";
            position:absolute; inset:0;
            border-radius:14px;
            background:transparent;
            z-index:-1;
          }

          /* caret aligned to link's left padding */
          .navbar.is-layout2 .service > .sub-menu-container::before{
            content:"";
            position:absolute;
            top:-8px; left:24px;
            width:14px; height:14px;
            transform:rotate(45deg);
            background:rgba(0,0,0,.72);
            border-left:1px solid rgba(255,255,255,.16);
            border-top:1px solid rgba(255,255,255,.16);
            z-index:0;
          }

          /* show rules */
          .navbar.is-layout2 .service:hover > .sub-menu-container{ display:block; }
          .navbar.is-layout2 .service.sub-open > .sub-menu-container{ display:block; }

          /* list + links */
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list{ list-style:none; margin:0; padding:4px 0; }
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li{ margin:0; }
          
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li > a{
  display:block;
  padding:6px 10px;
  font-size:13px;
  line-height:1.3;
  color:#ffffff;
}

.navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li > a:hover,
.navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li > a:focus{
  background:rgba(255,255,255,.12);
  color:#ffffff;
}


          /* mobile: accordion submenus (internal pages only).
             id-prefixed + high specificity so these reliably beat the
             legacy display:none rules in main.css (header-body-fixed scope),
             regardless of stylesheet load order or browser CSS caching. */
          @media (max-width:768px){
            #header .navbar.is-layout2 .navbar-nav > li.service:hover > .sub-menu-container,
            #header .navbar.is-layout2 .navbar-nav > li.work.service:hover > .sub-menu-container{
              display:none !important;
            }
            #header .navbar.is-layout2 .navbar-nav > li.service > .sub-menu-container,
            #header .navbar.is-layout2 .navbar-nav > li.work.service > .sub-menu-container{
              position:static !important;
              left:auto !important;
              right:auto !important;
              top:auto !important;
              transform:none !important;
              width:100% !important;
              max-width:none !important;
              max-height:none !important;
              min-width:0 !important;
              margin:0 !important;
              padding:4px 0 10px !important;
              box-shadow:none !important;
              border:0 !important;
              border-radius:0 !important;
              display:none !important;
              opacity:1 !important;
              visibility:visible !important;
              overflow:visible !important;
              background:rgba(0,0,0,0.35) !important;
              z-index:auto !important;
            }
            #header .navbar.is-layout2 .navbar-nav > li.service.sub-open > .sub-menu-container,
            #header .navbar.is-layout2 .navbar-nav > li.work.service.sub-open > .sub-menu-container{
              display:block !important;
              opacity:1 !important;
              visibility:visible !important;
            }
            #header .navbar.is-layout2 .navbar-nav > li.service > .sub-menu-container::before,
            #header .navbar.is-layout2 .navbar-nav > li.work.service > .sub-menu-container::before,
            #header .navbar.is-layout2 .navbar-nav > li.service > .sub-menu-container::after,
            #header .navbar.is-layout2 .navbar-nav > li.work.service > .sub-menu-container::after{
              display:none !important;
            }
          }
          /* ===== Nested Submenu Styling ===== */

.navbar.is-layout2 .has-submenu {
  position: relative;
  padding: 4px 8px;
}


.navbar.is-layout2 .sub-sub-menu {
  list-style: none;
  padding-left: 15px;
  margin-top: 6px;     /* add separation from title */
}

.navbar.is-layout2 .sub-sub-menu li a {
  display:block;
  padding:5px 8px;
  font-size:12px;
  
}

.navbar.is-layout2 .sub-sub-menu li a:hover {
  background: rgba(255,255,255,.12);
  color: #ffffff;
}
          
        `}</style>
      )}

      <nav
        className={`navbar navbar-default navbar-expand-md ${
          small ? "navbar-small" : "navbar-full"
        } ${forceSmallHeader ? "is-layout2" : ""} ${iconsOnly ? "nav-icons-only" : ""}`}
      >
        <div className="navbar-header">
          {forceSmallHeader ? (
            <RouterLink to="/" className="header-logo">
              <img src={logo} alt="logo" />
            </RouterLink>
          ) : (
            <ScrollLink to="home" className="header-logo" smooth={false} duration={800}>
              <img height="80px" src={logo} alt="logo" />
            </ScrollLink>
          )}

          <button
            onClick={() => setnavToggle(!navToggle)}
            type="button"
            className="navbar-toggle"
            data-bs-toggle="collapse"
            data-bs-target="#bs-example-navbar-collapse-1"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>

        <div
          className={
            navToggle ? "collapse navbar-collapse" : "collapse navbar-collapse show"
          }
          id="bs-example-navbar-collapse-1"
          onClick={onPanelClick}
        >
          <ul className="nav navbar-nav  navbar-right menu-item-6" id="navbar-full">
            <li className="current home">
              <span className="bg-icon">
                <i className="ion-ios-home"></i>
              </span>
              {showRotatedLabels && (
                <span className="rotated-title effect"><strong>Home</strong></span>
              )}

              <RouterLink
                to="/"
                className="link-item"
                aria-label="Home"
                onClick={() => setShowServicesList(false)}
              >
                {iconsOnly ? null : <strong>Home</strong>}
              </RouterLink>
            </li>


            <li className="about ab2">
              <span className="bg-icon">
                <i className="ion-ios-person"></i>
              </span>
              {showRotatedLabels && (
                <span className="rotated-title effect"><strong>About Us</strong></span>
              )}
              <RouterLink
                to="/about-us"
                aria-label="About"
                onClick={() => setShowServicesList(false)}
              >
                {iconsOnly ? null : "About"}
              </RouterLink>
            </li>

            {/* Mission with submenu */}
            <li className={`service ${showServicesList ? "sub-open" : ""}`}>
              <span className="bg-icon">
                <i className="ion-ios-star"></i>
              </span>
              {showRotatedLabels && (
                <span className="rotated-title effect"><strong>MISSION & GOALS</strong></span>
              )}
              

              <RouterLink
                className="link-item services-link"
                to="/mission-and-goals"
                aria-label="Mission"
                onClick={onMissionClick}
              >
                {iconsOnly ? null : "MISSION"}
              </RouterLink>

              <div className="sub-menu-container">
  <ul className="sub-menu-list">

    {/* 1. Americans4Hindus – PAC */}
    <li className="has-submenu">
  <a
  href="/americans4hindus-pac-political-action-committee"
  
  className="submenu-title"
>
  Americans4Hindus PAC - Political Action Committee
</a>


      <ul className="sub-sub-menu">
        <li>
          <RouterLink to="/a4h-pac">
            A4H PAC (Political Action Committee)
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/a4h-voter-guide">
            A4H Voter Guide
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/a4h-endorsed-candidates">
            A4H Endorsed Candidates 
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/a4h-state-pacs">
            A4H Multiple State PACS (38 Chapters)
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/a4h-press-releases">
            A4H Press Releases
          </RouterLink>
        </li>
        
      </ul>
    </li>

    {/* 2. Americans4Hindus – 501(c)(3) */}
    <li className="has-submenu">
      <a
  href="/americans4hindus-501c3-nonprofit"
  className="submenu-title"
  
>
  Americans4Hindus - 501(C)(3) - Non Profit Organization
</a>

      <ul className="sub-sub-menu">
        
        <li>
          <RouterLink to="/hindu-way-of-living">
            Hindu Way of Living (Duty towards Dharma)
          </RouterLink>
        </li>
        
        <li>
          <RouterLink to="/hindu-rajneeti-academy">
            Hindu Rajneeti Academy (Leadership Development)
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/alliances-and-coalitions">
            Alliances & Coalitions (Interfaith, Ethnicities, Nations)
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/hbsj-american-congressional-caucus">
            Hindu Buddhist Sikh Jain (HBSJ) American Congressional Caucus
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/a4h-temple-rakshak">
            A4H Temple Rakshak
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/a4h-charity-and-community">
            A4H Charitable & Community Services

          </RouterLink>
        </li>
      </ul>
    </li>
          <li className="has-submenu">
      <a
  href="/dharma-action-council"
  className="submenu-title"
  
>
  Americans4Hindus - 501(C)(4) DAC (Dharma Action Council)
</a>
<ul className="sub-sub-menu">
  <li>
          <RouterLink to="/legislative-lobbying">
            Legislative lobbying

          </RouterLink>
        </li>
        <li>
          <RouterLink to="/grassroots-advocacy">
            Grassroots Advocacy 

          </RouterLink>
        </li>
        <li>
          <RouterLink to="/government-relations">
            Government Relations Program 

          </RouterLink>
        </li>
        <li>
          <RouterLink to="/issue-based-campaigns">
            Issue-Based Campaigns (Non-Electoral) 

          </RouterLink>
        </li>
        <li>
          <RouterLink to="/public-policy-communications">
            Public Policy Communications 

          </RouterLink>
        </li>
        <li>
          <RouterLink to="/research-to-advocacy">
            Research-to-Advocacy Pipeline 

          </RouterLink>
        </li>
        <li>
          <RouterLink to="/advocacy-membership">
            Membership-Based Advocacy Infrastructure 

          </RouterLink>
        </li>
  </ul>
    </li>
    {/* 3. Festival of Globe – 501(c)(3) */}
    <li className="has-submenu">
      <a
  href="/festival-of-globe"
  className="submenu-title"
 
>
  Festival of Globe - 501(C)(3) Non Profit Organization
</a>

      <ul className="sub-sub-menu">
        <li>
          <RouterLink to="/fog-community-services">
            FOG Community Services
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/fog-festivals-and-programs">
            FOG Annual Festivals & Programs
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/fog-india-day-parade-and-fair">
            FOG Annual India Day Parade & Fair (Mela)
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/fog-proclamations-and-recognitions">
  FOG Proclamations & Recognitions
</RouterLink>
        </li>
      </ul>
    </li>

  </ul>
</div>
            </li>

            <li className={`work service ${showEventsList ? "sub-open" : ""}`}>
  <span className="bg-icon">
    <i className="ion-ios-calendar"></i>
  </span>

  {showRotatedLabels && (
    <span className="rotated-title effect"><strong>EVENTS & CALENDAR</strong></span>
  )}

  <RouterLink
    className="link-item services-link"
    to="/events-and-calender"
    aria-label="Events"
    onClick={onEventsClick}
  >
    {iconsOnly ? null : "EVENTS"}
  </RouterLink>

  <div className="sub-menu-container">
  <ul className="sub-menu-list">

    <li className="has-submenu">
      <RouterLink
        to="/events-and-calender#pac"
        className="submenu-title"
      >
        Americans4Hindus PAC - Political Action Committee Events
      </RouterLink>
    </li>

    <li className="has-submenu">
      <RouterLink
        to="/events-and-calender#npo"
        className="submenu-title"
      >
        Americans4Hindus - 501(C)(3) - Non Profit Organization Events
      </RouterLink>
    </li>
    <li className="has-submenu">
      <RouterLink
        to="/events-and-calender#dac"
        className="submenu-title"
      >
       Americans4Hindus - 501(C)(4) DAC (Dharma Action Council) Events
      </RouterLink>
    </li>

    <li className="has-submenu">
      <RouterLink
        to="/events-and-calender#fog"
        className="submenu-title"
      >
        Festival of Globe - 501(C)(3) Non Profit Organization Events 
      </RouterLink>
    </li>

  </ul>
</div>
</li>

            <li className="blog">
              <span className="bg-icon">
                <i className="ion-ios-paper"></i>
              </span>
              {showRotatedLabels && (
                <span className="rotated-title effect"><strong>MEDIA</strong></span>
              )}
              <RouterLink
                to="/media"
                aria-label="Media"
                onClick={() => setShowServicesList(false)}
              >
                {iconsOnly ? null : "MEDIA"}
              </RouterLink>
                
            </li>

            <li className="contact orange-transparent">
              <span className="bg-icon">
                <i className="ion-cash"></i>
              </span>

              {showRotatedLabels && (
                <span className="rotated-title effect"><strong>Donate</strong></span>
              )}

              <Link
  to="/donations"
  className="link-item"
  aria-label="Donate"
  onClick={() => setShowServicesList(false)}
>
  Donate
</Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar2;
